import React from 'react'

//Material-UI Core Components
import makeStyles from '@material-ui/core/styles/makeStyles';
import Radio from '@material-ui/core/Radio';

const customStyles = makeStyles(theme => ({
  root: {
    padding: 0
  }
}));

const TableRadio = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef()
    const resolvedRef = ref || defaultRef
    const classes = customStyles();

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate
    }, [resolvedRef, indeterminate])

    return (
      <>
        <Radio ref={resolvedRef} {...rest} indeterminate={indeterminate } classes={classes} color="secondary" size="small" />
      </>
    )
  }
)

export default TableRadio;